import { memo, useEffect, useState } from 'react';
import cx from 'classnames';
import { Text } from '../text/Text';
import './Button.scss';

import { SpinnerIcon } from '../Icons/index';

type ButtonProps = {
  className: string;
  isDisabled: boolean;
  isLoading?: boolean;
  lKey: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  type: 'submit' | 'reset' | 'button' | undefined;
  datatestid?: string;
};

export const Button = memo((props: ButtonProps) => {
  const { className, isDisabled, isLoading, lKey, onClick, type, datatestid } = props;
  const [disabled, setDisabled] = useState(isDisabled);
  const [loading, setLoading] = useState(Boolean(isLoading));

  useEffect(() => {
    setDisabled(isDisabled);
  }, [isDisabled]);

  useEffect(() => {
    if (isLoading !== undefined) {
      setLoading(isLoading);
      if (isLoading === true) {
        setDisabled(true);
      } else {
        setDisabled(isDisabled);
      }
    }
    // eslint-disable-next-line
  }, [isLoading]);

  return (
    <button
      className={cx('button-primary', className, {
        disabled: disabled,
      })}
      disabled={disabled}
      onClick={onClick}
      type={type}
      data-testid={datatestid}
    >
      {loading ? <SpinnerIcon /> : <Text lKey={lKey} />}
    </button>
  );
});

Button.displayName = 'Button';